import React, { useState, useEffect } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch } from 'react-redux';
import Popover from '@material-ui/core/Popover';
import PaletteIcon from '@material-ui/icons/Palette';
import IconButton from '@material-ui/core/IconButton';
import AddCircle from '@material-ui/icons/AddCircle';
import clsx from 'clsx';
import useTimeline from '../timeline/useTimeline';
import globals from '../../../globals/communityGlobals';
import { parseDateUtc } from '../../../utils/dates';
import { setAutoAllocationLogSetting } from '../../../actions/areas/dailyPlanning/autoAllocate';
import { setLiveTrackingSetting } from '../../../actions/areas/dailyPlanning/moreOptions';
import { PopoverStyle } from '../../../theme/AllocateBaseTheme';

const locale = globals.getArea('dailyPlanning');
const optionsList = [
  { label: locale.getMsg('liveTracking'), isChecked: true },
  { label: locale.getMsg('createLog'), isChecked: false },
];

export function MoreOptionsDialog({
  open,
  anchorEl,
  handleClose,
  showLiveTracking,
  clinicianModal,
  selectedDate,
  canAddNpa,
  showAddNpaForm,
}) {
  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();
  const { toggleFlag } = useTimeline();
  const today = parseDateUtc(new Date(globals.now)).format(globals.dateFormats.date);

  useEffect(() => {
    const mappedList = optionsList.reduce((acc, item) => {
      if (!showLiveTracking && item.label === locale.getMsg('liveTracking')) return acc;
      return { ...acc, [item.label]: item.isChecked };
    }, {});
    setOptions(mappedList);
  }, [showLiveTracking]);

  const toggleListItemClick = key => {
    const updatedList = {
      ...options,
      [key]: !options[key],
    };
    if (key === locale.getMsg('liveTracking')) dispatch(setLiveTrackingSetting(!options[key]));

    if (key === locale.getMsg('createLog')) {
      dispatch(setAutoAllocationLogSetting(!options[key]));
    }
    setOptions(updatedList);
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      className="popover-dark-theme"
      style={PopoverStyle}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      onClose={handleClose}
    >
      <div className={clsx(clinicianModal)}>
        <List className="list-items">
          {canAddNpa && selectedDate >= today && (
            <ListItem button className="list-item-without-padding" onClick={() => showAddNpaForm()}>
              <div className="modal-dialog">
                <IconButton size="small" aria-label="">
                  <AddCircle />
                </IconButton>
                <span className="label">Add NPA</span>
              </div>
            </ListItem>
          )}
          <ListItem button className="list-item-without-padding" onClick={() => toggleFlag('showLegend')}>
            <div className="modal-dialog">
              <IconButton className="palette-icon" size="small" aria-label="">
                <PaletteIcon />
              </IconButton>
              <span className="label">Palette Legend</span>
            </div>
          </ListItem>
          {Object.keys(options).map(op => (
            <ListItem button onClick={() => toggleListItemClick(op)} key={op} className="list-item-without-padding">
              <Checkbox
                checked={options[op]}
                value="secondary"
                color="primary"
                inputProps={{ 'aria-label': 'secondary checkbox' }}
              />
              <ListItemText primary={op} />
            </ListItem>
          ))}
        </List>
      </div>
    </Popover>
  );
}
